import { AlertCircle, CheckCircle, Danger, Information } from '@hourly-hds/icons/glyph';
import { useSyncExternalStore } from 'react';
import notificationStore from './notificationStore';
import styles from './SnackbarNotifications.module.css';

const IconMap = {
  error: <AlertCircle />,
  info: <Information />,
  success: <CheckCircle />,
  warning: <Danger />,
};

export default function SnackbarNotifications() {
  const { notifications } = useSyncExternalStore(
    notificationStore.subscribe,
    notificationStore.getSnapshot
  );
  const latestNotification = notifications[notifications.length - 1];
  if (!latestNotification) {
    return null;
  }

  return (
    <div className={styles.snackbarWrap}>
      <div className={`${styles.snackbar} ${styles[latestNotification.type]}`}>
        {IconMap[latestNotification.type]}
        {latestNotification.message}
      </div>
    </div>
  );
}
